export const colors = {
  colorTextDark: 'rgb(42, 53, 71)',
  colorTextLight: 'rgb(112 121 134)',
  colorFill: '#000000',
  colorGrey: '#F5F5F5',
  colorRed: '#B60A38',
  colorMutedGreen: '#464b4e',
  colorMutedYellow: '#AA8D6E',
  colorTextWhite: 'rgba(255, 255, 255, 0.8)',
  colorBackground: '#33383A',
};

export const fonts = {
  font1: 'Roboto, sans-serif',
  font2: 'futura-pt, sans-serif',
  font3: 'adobe-text-pro, serif',
};
